module.exports = __webpack_public_path__ + "static/media/rust.492b7dbe.svg";